import React from 'react';
import MasterLayout from "../MasterLayout";
import ContentCards from "./omni/ContentCards";
import EpisodeManager from "../EpisodeManager";

const Omni = () => {
    return (
        <MasterLayout>
            <EpisodeManager />
            <ContentCards />
        </MasterLayout>
    );
};

export default Omni;